import { PureComponent } from 'react';
import { string } from 'prop-types';
import { connect } from 'react-redux';
import { appointmentDraftSelectors, bookingsSelectors } from '~/api';
import { envConfigSelectors } from '../configuration';

export const withTabTitle = (Component) =>
  class ComponentWithTabTitle extends PureComponent {
    static propTypes = {
      tabTitle: string,
    };

    static defaultProps = {
      tabTitle: undefined,
    };

    componentDidUpdate() {
      const { tabTitle } = this.props;
      if (tabTitle) {
        document.title = tabTitle;
      }
    }

    render() {
      return <Component {...this.props} />;
    }
  };

export const mapStateToProps = (state) => {
  const draftAppointmentTypeId = appointmentDraftSelectors.selectAppointmentTypeId(state);
  const bookingAppointmentTypeId = bookingsSelectors.selectAppointmentTypeId(state);
  return {
    tabTitle: envConfigSelectors.selectTabTitle(draftAppointmentTypeId || bookingAppointmentTypeId)(
      state,
    ),
  };
};

export const ConnectedWithTabTitle = (Component) =>
  connect(mapStateToProps, null)(withTabTitle(Component));
